import { playNoiseBurst, playTone } from './proceduralSynth.js';
import { Random } from '../utils/Random.js';

/**
 * Matrix UI clicks + glitch stingers (procedural by default).
 */
export class UISounds {
  /**
   * @param {AudioContext} ctx
   * @param {GainNode} bus
   * @param {import('../config.js').CONFIG['audio']['uiSounds']} config
   */
  constructor(ctx, bus, config) {
    this._ctx = ctx;
    this._bus = bus;
    this._config = config;
    this._rng = new Random(config.seed);
  }

  playClick() {
    const detune = this._rng.range(-40, 40);
    playTone(this._ctx, this._bus, {
      type: 'square',
      frequency: this._config.clickFrequency,
      detune,
      duration: 0.06,
      gain: this._config.clickGain,
      attack: 0.002,
      decay: 0.045,
    });
    playTone(this._ctx, this._bus, {
      type: 'sine',
      frequency: this._config.clickFrequency * 2.2,
      detune,
      duration: 0.04,
      gain: this._config.clickGain * 0.35,
      attack: 0.001,
      decay: 0.03,
    });
  }

  playGlitch() {
    const slices = this._rng.int(2, 4);
    for (let i = 0; i < slices; i += 1) {
      const delay = i * this._rng.range(0.008, 0.025);
      const t0 = this._ctx.currentTime + delay;
      this._glitchSlice(t0);
    }
  }

  dispose() {
    this._rng = null;
  }

  /** @param {number} t0 */
  _glitchSlice(t0) {
    const osc = this._ctx.createOscillator();
    const env = this._ctx.createGain();
    osc.type = 'sawtooth';
    osc.frequency.setValueAtTime(
      this._rng.range(120, 420),
      t0,
    );
    osc.frequency.exponentialRampToValueAtTime(
      this._rng.range(40, 180),
      t0 + 0.04,
    );

    env.gain.setValueAtTime(0.0001, t0);
    env.gain.exponentialRampToValueAtTime(
      this._config.glitchGain,
      t0 + 0.003,
    );
    env.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.05);

    osc.connect(env);
    env.connect(this._bus);
    osc.start(t0);
    osc.stop(t0 + 0.06);

    playNoiseBurst(this._ctx, this._bus, {
      duration: 0.04,
      gain: this._config.glitchGain * 0.7,
      filterFreq: this._rng.range(600, 2200),
      filterQ: 1.2,
    });
  }
}
